import { Component, OnInit, OnDestroy, AfterViewInit } from '@angular/core';
import * as $ from 'jquery';
import { TarjetasListComponent } from './tarjetas-list.component';
import { TarjetasService } from './tarjetas.service';
import { ITarjeta } from './tarjeta';
import * as myGlobals from './../global';
import { errorMessageFromAjax } from '../services/ajax-error';

@Component({
  selector: 'pm-edit-tarjeta',
  templateUrl: './edit-tarjeta.component.html',
  styleUrls: ['./edit-tarjeta.component.sass'],
  providers: [TarjetasService]
})
export class EditTarjetaComponent implements OnInit, OnDestroy, AfterViewInit {
  tarjetas: ITarjeta[] = [];
  errorMessage = '';
  tarjeta: ITarjeta;

  constructor(public service: TarjetasService, private parent: TarjetasListComponent) {}

  ngOnInit() {
    console.log('EditTarjetaComponent: OnInit: id: ', this.parent.editnumber);
    this.getTarjeta(this.parent.editnumber);
  }

  ngAfterViewInit() {
    $('a[rel=marca-tarjeta]').addClass('selected');
  }

  edit(elemento): boolean {
    console.log('edit:' + elemento.parent.editnumber);
    const formData = {
      id: 0,
      brand: $('input[name=brand]').val() /* ,
      status: $('#brand option:selected').val() */
    };
    console.log(formData);

    const parentRef = this.parent;

    $.ajax({
      url: myGlobals.baseApi + '/webadmin/v1/cardbrand/' + elemento.parent.editnumber,
      dataType: 'json',
      headers: {
        sessionToken: localStorage.getItem('sessionToken')
      },
      contentType: 'application/json; charset=utf-8',
      type: 'PUT',
      data: JSON.stringify(formData)
    }).done(function(response) {
      console.log('delete sucess!!');
      parentRef.showTarjetas = true;
      parentRef.showAddTarjeta = false;
      parentRef.showEditTarjeta = false;
    }).fail(function(jqXHR) {
      alert('No se pudo actualizar la marca: ' + errorMessageFromAjax(jqXHR));
    });
    return false;
  }

  getTarjeta(id: number): any {
    this.service
      .getTarjeta(id)
      .subscribe(tarjeta => (this.tarjeta = tarjeta), error => (this.errorMessage = error as any));
  }

  cancelTarjeta(): void {
    this.parent.showTarjetas = true;
    this.parent.showAddTarjeta = false;
    this.parent.showEditTarjeta = false;
  }

  ngOnDestroy() {
    $('a[rel=marca-tarjeta]').removeClass('selected');
  }
}
